export interface ProofPoint {
  label: string
  detail: string
}

/** What a handled call leaves behind. */
export const proofPoints: ProofPoint[] = [
  { label: 'Understand', detail: 'Instant summary' },
  { label: 'Act', detail: 'Take permitted actions' },
  { label: 'Remember', detail: 'Caller history' },
]

export interface ProductCallout {
  label: string
  /** Calendars this capability connects to, shown as a small indicator. */
  integrations?: string[]
}

/** Restrained index of what the investor is looking at on the device. */
export const productCallouts: ProductCallout[] = [
  { label: 'Instant summary' },
  {
    label: 'Check availability & book',
    integrations: ['Google Calendar', 'Outlook Calendar'],
  },
  { label: 'Read or listen' },
  { label: 'Caller history' },
]
